import {ChangeDetectionStrategy, Component, inject, input, OnInit, output} from '@angular/core';
import {
  AttachProductCardFileParams,
  DeleteFileParams,
  GetFilesParams
} from "../../../../../types/product-card-files.types";
import {AttachFileParams} from "../../../../../../../../core/types/file.types";
import {
  unitEconomicsCalculationsFilesResourceType,
  unitEconomicsCalculationsFileType
} from "../../configs/unit-economics-calculations-config";
import {UnitEconomicsCalculationsFile} from "../../types/unit-economics-calculations-file.types";
import {FileCardComponent} from "../../../../../../../../shared/components/ui/file-card/file-card.component";
import {
  FileUploadCardComponent
} from "../../../../../../../../shared/components/ui/file-upload-card/file-upload-card.component";
import {
  UnitEconomicsCalculationsFilesStateService
} from "../../services/unit-economics-calculations-files-state.service";
import {UnitEconomicsCalculationsService} from "../../services/unit-economics-calculations.service";

@Component({
  selector: 'div[app-unit-economics-calculations-files]',
  imports: [
    FileCardComponent,
    FileUploadCardComponent
  ],
  templateUrl: './unit-economics-calculations-files.component.html',
  styleUrl: './unit-economics-calculations-files.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitEconomicsCalculationsFilesComponent implements OnInit {
  unitEconomicsCalculationId = input.required<number>();
  isEditModeActive = input<boolean>(false);
  setLoadingState = output<boolean>();

  private unitEconomicsCalculationsService: UnitEconomicsCalculationsService = inject(UnitEconomicsCalculationsService);
  private unitEconomicsCalculationsFilesStateService: UnitEconomicsCalculationsFilesStateService = inject(UnitEconomicsCalculationsFilesStateService);

  public readonly unitEconomicsCalculationsFileType = unitEconomicsCalculationsFileType;

  public async ngOnInit(): Promise<void> {
    await this.getFiles();
  }

  public getFilesById(): Array<UnitEconomicsCalculationsFile> {
    return this.unitEconomicsCalculationsFilesStateService.getUnitEconomicsCalculationsFilesById(this.unitEconomicsCalculationId());
  }

  public async handleDelete(isImage: boolean, file: UnitEconomicsCalculationsFile):  Promise<void> {
    const deleteFileParams: DeleteFileParams = {
      path: unitEconomicsCalculationsFilesResourceType.path,
      id: file.id
    };

    this.unitEconomicsCalculationsService.deleteFile(deleteFileParams)
      .then(() => this.unitEconomicsCalculationsFilesStateService.deleteFileById(file.id, this.unitEconomicsCalculationId()));
  }

  public async attachFile({ parentId, fileId }: AttachFileParams): Promise<void> {
    const attachFileParams: AttachProductCardFileParams = {
      path: unitEconomicsCalculationsFilesResourceType.path,
      body: {
        fileId: fileId,
        unitEconomicsCalculationsId: parentId
      }
    };

    await this.unitEconomicsCalculationsService.attachFile<UnitEconomicsCalculationsFile>(attachFileParams)
      .then((data) => this.unitEconomicsCalculationsFilesStateService.updateUnitEconomicsCalculationsFilesState(this.unitEconomicsCalculationId(), data));
  }

  private async getFiles(): Promise<void> {
    this.setLoadingState.emit(true);
    const params: GetFilesParams = {
      path: unitEconomicsCalculationsFilesResourceType.path,
      params: { unitEconomicsCalculationsId: this.unitEconomicsCalculationId() }
    };

    await this.unitEconomicsCalculationsService.getFiles(params)
      .then((data) => this.unitEconomicsCalculationsFilesStateService.setUnitEconomicsCalculationsFilesState(this.unitEconomicsCalculationId(), data))
      .finally(() => this.setLoadingState.emit(false));
  }
}
